package org.moxultimate.topwithmox.pages

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.add
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobweb.core.layout.Layout
import org.moxultimate.topwithmox.components.layouts.PageLayoutData
import org.moxultimate.topwithmox.product.ui.ProductPage

@InitRoute
fun initProductsRoute(ctx: InitRouteContext) {
    ctx.data.add(PageLayoutData("Top Products"))
}

@Page
@Layout(".components.layouts.PageLayout")
@Composable
fun ProductsRoute() {
    ProductPage()
}
